/* Khaled product page: gallery, zoom, wrist fit anchor, compare side by side, related picks, sticky bar.
   Adding to the cart is done by kw.js (forms with data-kw-add). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = function (cents) { var d = cents / 100; return '$' + (d % 1 ? d.toFixed(2) : String(d)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------- spec lines, read the same way as the Liquid section ---------- */
  function specs(html) {
    /* 24 Oct: read the description with DOMParser; it never loads images or runs code inside the text. */
    var o = {}, box = new DOMParser().parseFromString(html || '', 'text/html');
    [].forEach.call(box.querySelectorAll('li'), function (li) {
      var t = li.textContent.replace(/\s+/g, ' ').trim(), i = t.indexOf(':');
      if (i < 1) return;
      var k = t.slice(0, i).trim().toLowerCase(), v = t.slice(i + 1).trim();
      if (v && !o[k]) o[k] = v;
    });
    var gl = (o.gender || '').toLowerCase(), g = '';
    if (/unisex/.test(gl)) g = 'Unisex';
    else if (/kid|boy|girl/.test(gl)) g = 'Kids';
    else if (/lad|wom|female/.test(gl)) g = 'Women';
    else if (/gent|men|male/.test(gl)) g = 'Men';
    var bm = (o['band material'] || '').toLowerCase(), bt = '';
    [['mesh', 'mesh'], ['leather', 'leather'], ['silicone', 'silicone'], ['rubber', 'rubber'], ['nylon', 'fabric'], ['fabric', 'fabric'], ['textile', 'fabric'], ['ceramic', 'ceramic'], ['bangle', 'bangle'], ['steel', 'steel'], ['bracelet', 'steel'], ['metal', 'steel']].some(function (x) { if (bm.indexOf(x[0]) > -1) { bt = x[1]; return true; } });
    var bc = o['band color'] || o['band colour'] || '';
    var band = bc ? (!bt || bc.toLowerCase().indexOf(bt) > -1 ? bc : bc + ' ' + bt) : (o['band material'] || '');
    var mm = parseFloat((o['case diameter'] || '').replace(',', '.'));
    return {
      g: g, mm: mm >= 18 && mm <= 60 ? mm : 0,
      move: o.movement || '', wr: o['water resistance'] || o['water resistant'] || '',
      dial: o['dial color'] || o['dial colour'] || '', band: band
    };
  }

  function shortName(title, vendor) {
    var n = title || '';
    if (n === n.toUpperCase()) {
      var V = (vendor || '').toUpperCase();
      n = n.replace(V + ', ', '').replace(V + ' ', '');
      n = n.split(' ').map(function (w) { return /\d/.test(w) || w.length <= 2 || !/[AEIOU]/.test(w) ? w : w.charAt(0) + w.slice(1).toLowerCase(); }).join(' ');
    } else if (vendor && n.indexOf(vendor + ' ') === 0) n = n.slice(vendor.length + 1);
    n = n.replace(/ (Men's|Women's) Smartwatch$/, ' Smartwatch').replace(/ (Kids'?|Men's|Women's|Unisex) Watch$/, '').replace(/ Watch$/, '').trim();
    return n || title;
  }

  /* ---------- gallery ---------- */
  function gallery(sec) {
    var gal = sec.querySelector('[data-kw-gal]'); if (!gal) return;
    var track = gal.querySelector('.kw-pd__track'), slides = gal.querySelectorAll('.kw-pd__slide');
    var tabs = gal.querySelectorAll('.kw-pd__rail button'), dots = gal.querySelectorAll('.kw-pd__dots i'), i = 0;
    function go(n) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      [].forEach.call(tabs, function (t, j) { t.setAttribute('aria-selected', String(j === i)); });
      [].forEach.call(dots, function (d, j) { d.classList.toggle('on', j === i); });
    }
    [].forEach.call(tabs, function (t) { t.addEventListener('click', function () { go(+t.dataset.i); }); });
    if (slides.length > 1) {
      var x0 = null, stage = gal.querySelector('[data-kw-stage]');
      stage.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') x0 = e.clientX; });
      stage.addEventListener('pointerup', function (e) { if (x0 == null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); });
      stage.addEventListener('pointercancel', function () { x0 = null; });
    }
    /* zoom: only on a mouse, only for photos big enough, never past the photo's real pixels */
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var hint = gal.querySelector('.kw-pd__zoomhint');
    [].forEach.call(slides, function (s) {
      if (s.dataset.zoom !== '1') return;
      var img = s.querySelector('img'); if (!img) return;
      if (hint) hint.hidden = false;
      s.addEventListener('mouseenter', function () {
        var z = Math.min(2.2, (img.naturalWidth || 0) / (img.getBoundingClientRect().width || 1));
        if (z < 1.15) return;
        s.style.setProperty('--zs', z.toFixed(2)); s.classList.add('is-zoom'); if (hint) hint.style.opacity = '0';
      });
      s.addEventListener('mousemove', function (e) {
        var r = s.getBoundingClientRect();
        s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
      s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); if (hint) hint.style.opacity = ''; });
    });
  }

  /* ---------- buy box ---------- */
  function buy(sec) {
    var sel = sec.querySelector('[data-kw-var]'), price = sec.querySelector('[data-kw-price]');
    if (sel && price) sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; price.textContent = o.dataset.price; });
    var fit = document.getElementById('kw-fit');
    function openFit(scroll) {
      var d = fit && fit.querySelector('details'); if (!d) return;
      d.open = true;
      if (scroll) setTimeout(function () { fit.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
    }
    if (location.hash === '#kw-fit') openFit(true);
    window.addEventListener('hashchange', function () { if (location.hash === '#kw-fit') openFit(true); });
  }

  /* ---------- sticky add to cart ---------- */
  function sticky(sec) {
    var bar = document.querySelector('[data-kw-sticky]'), main = sec.querySelector('[data-kw-main] button[type=submit]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-kw-stickyadd]');
    new IntersectionObserver(function (es) {
      var e = es[0], on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on)); btn.tabIndex = on ? 0 : -1;
    }).observe(main);
    btn.addEventListener('click', function () {
      var f = main.form; if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else main.click();
    });
    document.addEventListener('kw:cart', function () { if (main.classList.contains('is-done')) btn.textContent = 'Added'; });
  }

  /* ---------- compare side by side ---------- */
  function compare(sec) {
    var box = document.querySelector('[data-kw-cmp]'); if (!box) return;
    var A; try { A = JSON.parse(box.querySelector('[data-kw-a]').textContent); } catch (e) { return; }
    A.s = specs(A.description); A.price = A.price; A.name = A.name || shortName(A.title, A.vendor);
    var card = box.querySelector('[data-kw-cmpcard]'), rowsEl = box.querySelector('[data-kw-rows]'), note = box.querySelector('[data-kw-note]');
    var chips = box.querySelectorAll('.kw-cmp__chip'), formB = box.querySelector('[data-kw-addb]'), wa = box.querySelector('[data-kw-wa2]');
    var waBase = wa ? wa.getAttribute('href').split('?')[0] : '';
    /* both buttons say Add to cart; each sits under its own watch */
    var ma = box.querySelector('.kw-cmp__add.is-main');
    if (ma) { ma.setAttribute('aria-label', 'Add ' + A.vendor + ' ' + A.name + ' to cart'); if (!ma.disabled) ma.textContent = 'Add to cart'; else ma.textContent = 'Sold out'; }
    var cache = {}, token = 0;

    function load(h) {
      if (cache[h]) return Promise.resolve(cache[h]);
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
        var m = (p.media || [])[0] || {};
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
        var B = { handle: p.handle, title: p.title, vendor: p.vendor, name: shortName(p.title, p.vendor), price: p.price, url: p.url,
          img: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=800' : '',
          w: m.width || 0, h: m.height || 0, vid: v.id, avail: !!v.available, s: specs(p.description) };
        cache[h] = B; return B;
      });
    }

    function fill(fig, P) {
      var img = fig.querySelector('img');
      if (P.img) { img.src = P.img; img.alt = P.vendor + ' ' + P.name; }
      img.style.maxHeight = P.h ? Math.round(P.h * Math.min(1, 800 / (P.w || 800))) + 'px' : '';
      fig.querySelector('.kw-cmp__b').textContent = P.vendor;
      fig.querySelector('.kw-cmp__n').textContent = P.name;
    }

    /* 24 Oct: real scale. Each photo is measured: how wide the case is inside the photo (crown left out) and where its
       centre sits. Both watches are then drawn so their cases match their real diameters, centred on the same line. */
    var meas = {};
    function measure(src) {
      if (!src) return Promise.reject();
      if (meas[src]) return meas[src];
      meas[src] = new Promise(function (ok, no) {
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var W = 240, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
            var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
            var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, W, H);
            var d = cx.getImageData(0, 0, W, H).data;
            function px(x, y) { var i = (y * W + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
            var bg = [px(1, 1), px(W - 2, 1), px(1, H - 2), px(W - 2, H - 2)].reduce(function (s, c) { return [s[0] + c[0] / 4, s[1] + c[1] / 4, s[2] + c[2] / 4, s[3] + c[3] / 4]; }, [0, 0, 0, 0]);
            function ink(x, y) { var c = px(x, y); if (bg[3] < 128) return c[3] > 60; return c[3] > 60 && Math.abs(c[0] - bg[0]) + Math.abs(c[1] - bg[1]) + Math.abs(c[2] - bg[2]) > 54; }
            var rows = [], mids = [];
            for (var y = 0; y < H; y++) {
              var L = -1, R = -1;
              for (var x = 0; x < W; x++) if (ink(x, y)) { L = x; break; }
              if (L < 0) continue;
              for (x = W - 1; x >= L; x--) if (ink(x, y)) { R = x; break; }
              rows.push([y, L, R]); mids.push((L + R) / 2);
            }
            if (rows.length < 10) return no();
            mids.sort(function (p, q) { return p - q; });
            var c = mids[mids.length >> 1], best = 0;
            rows.forEach(function (r) { r[3] = 2 * Math.min(c - r[1], r[2] - c); if (r[3] > best) best = r[3]; });
            var ys = rows.filter(function (r) { return r[3] >= best * 0.97; }).map(function (r) { return r[0]; });
            var cy = ys.reduce(function (s, v) { return s + v; }, 0) / ys.length;
            if (best < W * 0.08) return no();
            ok({ cw: best / W, cy: cy / H, ar: H / W });
          } catch (e) { no(); }
        };
        im.onerror = no;
        im.src = src.replace(/([?&])width=\d+/, '$1width=480');
      });
      return meas[src];
    }
    var rs = 0;
    function realScale(B) {
      var a = A.s, b = B.s, my = ++rs;
      var fa = card.querySelector('[data-side=a] .kw-cmp__ph'), fb = card.querySelector('[data-side=b] .kw-cmp__ph');
      return Promise.all([measure(A.img), measure(B.img)]).then(function (m) {
        if (my !== rs) return;
        var ma = a.mm || b.mm || 1, mb = b.mm || a.mm || 1, Hh = fa.clientHeight, Cw = fa.clientWidth;
        function wmax(r) { return Math.min(Cw, Hh / (2 * Math.max(r.cy, 1 - r.cy) * r.ar)); }
        var k = Math.min(wmax(m[0]) * m[0].cw / ma, wmax(m[1]) * m[1].cw / mb);
        [[fa, m[0], ma], [fb, m[1], mb]].forEach(function (t) {
          var w = t[2] * k / t[1].cw, img = t[0].querySelector('img');
          t[0].classList.add('is-real');
          img.style.width = w.toFixed(1) + 'px';
          img.style.top = (Hh / 2 - t[1].cy * w * t[1].ar).toFixed(1) + 'px';
        });
      });
    }

    function show(B) {
      var a = A.s, b = B.s;
      fill(card.querySelector('[data-side=a]'), A); fill(card.querySelector('[data-side=b]'), B);
      var ia = card.querySelector('[data-side=a] img'), ib = card.querySelector('[data-side=b] img');
      [ia, ib].forEach(function (im) { im.parentNode.classList.remove('is-real'); im.style.width = ''; im.style.top = ''; });
      if (a.mm && b.mm) {
        var big = Math.max(a.mm, b.mm);
        ia.style.setProperty('--h', (a.mm / big * 100).toFixed(1) + '%');
        ib.style.setProperty('--h', (b.mm / big * 100).toFixed(1) + '%');
        note.textContent = a.mm === b.mm ? 'Both cases are ' + a.mm + ' mm, so they are shown at the same size.' : 'Shown at real scale: ' + a.mm + ' mm and ' + b.mm + ' mm cases.';
      } else {
        ia.style.setProperty('--h', '100%'); ib.style.setProperty('--h', '100%');
        note.textContent = 'Case size is not listed for one of these watches, so both cases are shown at the same size.';
      }
      realScale(B).catch(function () {});
      var rows = [
        ['Price', money(A.price), money(B.price)],
        ['Case diameter', a.mm ? a.mm + ' mm' : '', b.mm ? b.mm + ' mm' : ''],
        ['Movement', a.move, b.move],
        ['Water resistance', a.wr, b.wr],
        ['Strap', a.band, b.band],
        ['Dial', a.dial, b.dial],
        ['For', a.g, b.g]
      ];
      rowsEl.innerHTML = rows.filter(function (r) { return r[1] || r[2]; }).map(function (r) {
        var diff = String(r[1]).toLowerCase() !== String(r[2]).toLowerCase();
        return '<div class="kw-cmp__row"><span>' + r[0] + '</span><span>' + esc(r[1] || '–') + '</span><span' + (diff ? ' class="is-diff"' : '') + '>' + esc(r[2] || '–') + '</span></div>';
      }).join('');
      formB.querySelector('[name=id]').value = B.vid || '';
      var bb = formB.querySelector('button');
      bb.classList.remove('is-done'); bb.disabled = !B.avail; bb.textContent = B.avail ? 'Add to cart' : 'Sold out';
      bb.setAttribute('aria-label', B.avail ? 'Add ' + B.vendor + ' ' + B.name + ' to cart' : B.name + ' is sold out');
      if (wa) wa.href = waBase + '?text=' + encodeURIComponent("Hello, I can't decide between the " + A.vendor + ' ' + A.name + ' (' + location.origin + A.url + ') and the ' + B.vendor + ' ' + B.name + ' (' + location.origin + B.url + '). Can you help me choose?');
      card.hidden = false;
    }

    function pick(h, btn) {
      [].forEach.call(chips, function (c) { c.setAttribute('aria-pressed', String(c === btn)); });
      var t = ++token;
      card.style.opacity = '.55';
      load(h).then(function (B) { if (t === token) { last = B; show(B); card.style.opacity = ''; } }).catch(function () { card.style.opacity = ''; });
    }
    [].forEach.call(chips, function (c) { c.addEventListener('click', function () { pick(c.dataset.h, c); }); });

    /* search all watches */
    var q = box.querySelector('[data-kw-q]'), res = box.querySelector('[data-kw-res]'), timer;
    if (q && res) {
      q.addEventListener('input', function () {
        clearTimeout(timer);
        var v = q.value.trim();
        if (v.length < 2) { res.hidden = true; return; }
        timer = setTimeout(function () {
          fetch(root + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
            .then(function (r) { return r.json(); })
            .then(function (j) {
              var ps = ((j.resources || {}).results || {}).products || [];
              ps = ps.filter(function (p) { return p.handle !== A.handle; });
              res.innerHTML = ps.length ? ps.map(function (p) {
                return '<li><button type="button" data-h="' + esc(p.handle) + '">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="" width="36" height="36">' : '') + '<span>' + esc(shortName(p.title, p.vendor)) + '<small>' + esc(p.vendor) + ' · $' + esc(String(p.price).replace(/\.00$/, '')) + '</small></span></button></li>';
              }).join('') : '<li class="is-empty">No watches found.</li>';
              res.hidden = false;
            }).catch(function () { res.hidden = true; });
        }, 220);
      });
      res.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-h]'); if (!b) return;
        res.hidden = true; q.value = ''; pick(b.dataset.h, null);
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      document.addEventListener('click', function (e) { if (!e.target.closest('.kw-cmp__search')) res.hidden = true; });
      q.addEventListener('keydown', function (e) { if (e.key === 'Escape') { res.hidden = true; q.blur(); } });
    }
    var last = null, rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (last && !card.hidden) realScale(last).catch(function () {}); }, 200); });
    if (chips[0]) pick(chips[0].dataset.h, chips[0]);
  }

  /* ---------- you may also like (Shopify related products) ---------- */
  function recs() {
    var el = document.querySelector('[data-kw-more-recs]');
    if (!el || el.dataset.done || !el.dataset.url) return;
    el.dataset.done = '1';
    var go = function () {
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
        var d = document.createElement('div'); d.innerHTML = t;
        var n = d.querySelector('[data-kw-more-recs]');
        if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else go();
  }

  function init() {
    var sec = document.querySelector('[data-kw-pd]');
    if (sec && !sec.dataset.ready) { sec.dataset.ready = '1'; gallery(sec); buy(sec); sticky(sec); compare(sec); }
    recs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
